import React from 'react';
import {
    Box,
    Button,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import searchIcon from "../../assets/images/search-normal.svg";
import CustomTable from "../customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import {useEffect, useState} from "react";
import AccountDetails from "../AccountDetails/AccountDetails";
import AddNewAccount from "../../pages/AddNewAccount/AddNewAccount";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {AccountsListService} from "./AccountsListService";
import {convertCurrencyFormat, convertCurrencyFormatPositiveNegative} from "../../utils/numberConvertor";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {css} from "@emotion/css";
import {preparePositiveNegativeNumberCell, prepareStatusCell} from "../../utils/PrepareTableCellStyle";


let selectedItemId = -1
const ListOfAccounts = ({isMain = true, rowOnClicked}) => {

    let page = 0
    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new AccountsListService(fundID, token, snackbar, loading)

    const [filterText, setFilterText] = useState("");
    const [filterSelectedValue, setFilterSelectedValue] = useState("full-name");


    const [pageCount, setPageCount] = useState(0);
    const [itemCount, setItemCount] = useState(0);

    const [needRefresh, setNeedRefresh] = useState(false);
    const [accountsList, setAccountsList] = useState([]);

    const showEventsContent = (rowId, index) => {
        if (isMain) {
            selectedItemId = rowId
            setOpenDialog(true)
        } else {
            rowOnClicked({
                id: accountsList[index].id,
                name: accountsList[index].fullName,
                phoneNumber: accountsList[index].nationalCode,
                personalCode: accountsList[index].nationalCode,
                group: accountsList[index].group,
            })
        }
    }

    const handleChange = (event, value) => {
        page = value - 1
        getListDataFromServer()
    };

    //modal-start


    const [openDialog, setOpenDialog] = useState(false)
    const handleClickOpen = () => {
        setOpenDialog(true);
    };
    const handleClose = () => {
        setOpenDialog(false);
        selectedItemId = -1
        if (needRefresh) {
            getListDataFromServer()
        }
    }

    const [openDialogAddNewAccount, setOpenDialogAddNewAccount] = useState(false)
    const handleClickOpenAddNewAccount = () => {
        setOpenDialogAddNewAccount(true);
    };
    const handleCloseAddNewAccount = () => {
        setOpenDialogAddNewAccount(false);
        if (needRefresh) {
            getListDataFromServer()
        }
    }

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getListDataFromServer()
        }
    }, [])

    function prepareFilterData(filterText, filterSelected) {
        switch (filterSelected) {
            case "full-name":
                return {
                    "full-name": filterText
                }
            case "national-code":
                return {
                    "national-code": filterText
                }
            case "group-name":
                return {
                    "group-name": filterText
                }
            case "deposit-account-number":
                return {
                    "deposit-account-number": filterText
                }
            default:
                return {}
        }
    }

    function getListDataFromServer(filter = filterText, filterSelected = filterSelectedValue) {
        loading(setLoadingStateDispatch(true))

        service.getCashAccountsList(
            page,
            fundID,
            prepareFilterData(filter, filterSelected)
        ).then(response => {

            setAccountsListData(response)
            loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت اطلاعات حساب ها", snackbar, loading)
        })
    }


    function setAccountsListData(accountsData) {

        setItemCount(accountsData.numberOfItems)
        setPageCount(accountsData.totalPage)
        setAccountsList([])

        accountsData.data.map((item, index) => {
            setAccountsList(prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 20) + index + 1,
                    item.number,
                    item.ownerFirstName,
                    item.ownerLastName,
                    item.ownerNationalCode,
                    item.OwnerGroupName,
                    item.balance,
                    item.enabled,
                    item.cleared
                )
            ])
        })

    }


    return (
        <>
            {
                <AccountDetails
                    openDialog={openDialog}
                    handleClose={handleClose}
                    handleClickOpen={handleClickOpen}
                    needRefresh={setNeedRefresh}
                    selectedId={selectedItemId}
                />

            }
            {
                <AddNewAccount
                    openDialog={openDialogAddNewAccount}
                    handleClose={handleCloseAddNewAccount}
                    handleClickOpen={handleClickOpenAddNewAccount}
                    needRefresh={setNeedRefresh}
                />
            }
            <section className='pageContainer' style={{overflowY: 'hidden'}}>

                <Box className={`${isMain ? "d-flex flex-row w-100" : "d-none"}`}
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'baseline'}}>
                        <Typography variant={"h5"}>
                            حساب ها
                        </Typography>
                        {itemCount > 0 ?
                            <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                {" " + itemCount + " حساب ثبت شده "}
                            </Typography> :
                            ''}
                    </section>
                    <Button
                        variant='contained'
                        onClick={_ => {
                            setOpenDialogAddNewAccount(true)
                        }}
                        // startIcon={<DeleteIcon/>}
                    >
                        افزودن حساب جدید
                    </Button>
                </Box>
                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '0 0 1.2rem 0',
                         justifyContent: 'start',
                         alignContent: 'start',
                         alignItems: 'start'
                     }}>
                    <Grid sm={12} md={8} lg={8} xl={8} className='modalTextFieldContainer'>
                        <TextField
                            value={filterText}
                            onChange={e => {
                                setFilterText(e.target.value)
                                getListDataFromServer(e.target.value)
                            }}
                            className='w-100'
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={searchIcon} alt=""/>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined" label="جستجو"
                            placeholder="عبارت مورد نظر را وارد نمایید..."/>
                    </Grid>
                    <Grid sm={12} md={8} lg={4} xl={4} className='modalTextFieldContainer'>
                        <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="filled-age-native-simple">جستجو بر اساس</InputLabel>
                            <Select label="جستجو بر اساس"
                                    value={filterSelectedValue}
                                    onChange={e => {
                                        setFilterSelectedValue(e.target.value)
                                        getListDataFromServer(filterText, e.target.value)
                                    }}>
                                <option value={"full-name"}>نام و نام خانوادگی</option>
                                <option value={"national-code"}>کد ملی</option>
                                <option value={"group-name"}>نام گروه</option>
                                <option value={"deposit-account-number"}>شماره حساب</option>
                            </Select>
                        </FormControl>
                    </Grid>
                </Box>

                <CustomTable
                    header={columns}
                    data={accountsList}
                    rowClicked={showEventsContent}
                />

                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </>

    )

    function prepareGroupsJsonList(
        id, number, accountCode, ownerFirstName, ownerLastName, ownerNationalCode,
        OwnerGroupName, balance, enabled, cleared) {

        return {
            id: id,
            number: number,
            fullName: ownerFirstName + " " + ownerLastName,
            nationalCode: ownerNationalCode,
            accountCode: accountCode,
            group: OwnerGroupName,
            balance: preparePositiveNegativeNumberCell(balance),
            status: prepareStatusCell(!cleared, "فعال", "بسته شده"),
        }
    }

}
export default ListOfAccounts;


const columns = [
    {
        id: 'number',
        label: '#',
        align: 'right',

    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی',
        align: 'right',
    },
    {
        id: 'nationalCode',
        label: 'کد ملی',
        align: 'right',
    },
    {
        id: 'accountCode',
        label: 'کد حساب',
        align: 'right',
    },
    {
        id: 'group',
        label: 'گروه',
        align: 'right',
    },
    {
        id: 'balance',
        label: 'موجودی (ریال)',
        align: 'right',
    },
    {
        id: 'status',
        label: 'وضعیت',
        align: 'right',
    },
];